import React from "react";
import { User } from "@/types/user";

interface UserAvatarProps {
  user: User;
  size?: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "w-6 h-6 text-xs",
  md: "w-8 h-8 text-sm",
  lg: "w-12 h-12 text-base",
};

export default function UserAvatar({ user, size = "md" }: UserAvatarProps) {
  const sizeClass = sizeClasses[size];

  if (user.photoURL) {
    return (
      <img
        src={user.photoURL}
        alt={user.displayName || user.email || "User"}
        className={`${sizeClass} rounded-full object-cover`}
      />
    );
  }

  const initial = user.displayName?.[0] || user.email?.[0] || user.id[0] || "U";
  const bgColor = `bg-primary`;

  return (
    <div
      className={`${sizeClass} ${bgColor} rounded-full flex items-center justify-center text-white font-semibold`}
    >
      {initial.toUpperCase()}
    </div>
  );
}

